import { memo } from 'react';
import { List } from 'foundations-components/transitional/components/List';
import SourceLabelSection from './SourceLabelSection';
import SourceByline from './SourceByline';
import SourceInterpretationSentence from './SourceInterpretationSentence';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SourceInterpretation = ({
  label,
  description,
  user,
  instance,
  maxWidth,
  isSentence
}) => {
  if (isSentence) {
    return /*#__PURE__*/_jsx(SourceInterpretationSentence, {
      label: label,
      description: description,
      instance: instance,
      user: user
    });
  }
  // minimum maxWidth (if specified) is 100
  const width = maxWidth && maxWidth < 100 ? 100 : maxWidth;
  return /*#__PURE__*/_jsxs(List, {
    children: [/*#__PURE__*/_jsx(SourceLabelSection, {
      label: label,
      description: description,
      instance: instance,
      width: width
    }), user && /*#__PURE__*/_jsx(SourceByline, {
      user: user,
      width: width
    })]
  });
};
export default /*#__PURE__*/memo(SourceInterpretation);